import { mergeStyleSets } from "@fluentui/react";
export const getNavigationStyles = (isNavCollapsed: boolean) => {
  const rootStyle = {
    asideContainer: {
      marginTop: "48px",
      position: "absolute",
      "& > div > div > nav > div": {
        width: isNavCollapsed
          ? "calc(var(--scrollbar-width) + 48px)"
          : "calc(228px + var(--scrollbar-width))",
      },
      "& > div > div > nav": {
        position: "fixed",
      },
    },
  };
  return mergeStyleSets(rootStyle);
};
